import { HorizontalRule } from '@mui/icons-material'
import { Box, FormLabel, Rating, Typography } from '@mui/material'
import { TextField } from 'components'
import { theme } from 'config'
import { observer } from 'mobx-react'
import { Course } from 'models'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export interface ICourseRatingProps {
  course:         Course
  setRatingAdded: Dispatch<SetStateAction<boolean>>
}

export const CourseRating = (observer((props: ICourseRatingProps): JSX.Element => {
  const { course, setRatingAdded } = props;
  const { t } = useTranslation();
  return (
    <Box> 
      <Typography color={theme.palette.error.main} sx={{ mb: '2rem', mt: '2rem', textAlign: 'center' }} variant='h4'>
        <HorizontalRule />
      </Typography>
      <Typography sx={{ mb: '2rem', mt: '2rem' }} variant='h4'>
        {t('add_rating')}
      </Typography>
      <Box
        display        = 'flex'
        justifyContent = 'center'
        width          = '100%'
        pt             = {2}
        pb             = {4}
        sx             = {{ overflow: 'hidden' }}
      >
        <Rating
          name     = "simple-controlled"
          value    = {course.rating}
          onChange = {(event, newValue) => {
            course.setRating(newValue);
            setRatingAdded(true);
            if(!newValue)
              setRatingAdded(false);
          }}
        />
        <Typography color={theme.palette.error.main}>
          *
        </Typography>
      </Box>
      <Box
        display       = 'flex'
        flexDirection = 'column'
        textAlign     = 'left'
      >
        <FormLabel>
          {t('general_comments_about_the_course')}
        </FormLabel>
        <TextField
          hiddenLabel
          multiline
          debounced
          fullWidth   = {true} 
          minRows     = '3'
          variant     = 'outlined'
          delay       = {300}
          value       = {course.comment}
          onChange    = {(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            course.setComment(e.target.value)
          }
        />
      </Box>
    </Box>
  )
}));
